import React from 'react';
import {
    LayoutDashboard,
    Shield
} from 'lucide-react';

const ScenarioSidebar = ({
    scenarios,
    selectedScenario,
    onSelectScenario,
    isResponsibleMode = false
}) => {

    return (
        <div className="h-full flex flex-col bg-white border-r border-gray-200">

            {/* Global Dashboard Selection */}
            <div className="p-3 border-b border-gray-100">
                <button
                    onClick={() => onSelectScenario(null)}
                    className={`w-full group relative overflow-hidden rounded-lg p-2.5 text-left transition-all duration-200 border ${selectedScenario === null
                        ? 'bg-blue-50 border-blue-200 text-blue-900 shadow-sm'
                        : 'bg-white border-transparent hover:bg-gray-50 text-gray-700'
                        }`}
                >
                    <div className="flex items-center gap-2 font-semibold text-sm">
                        <LayoutDashboard className={`w-4 h-4 ${selectedScenario === null ? 'text-blue-600' : 'text-gray-400'}`} />
                        <span>Vue Globale</span>
                    </div>
                </button>
            </div>

            {/* List */}
            <div className="flex-1 overflow-y-auto p-2 space-y-0.5 custom-scrollbar">
                <div className="text-[10px] font-bold text-gray-400 uppercase tracking-wider px-2 mb-1.5 mt-2">
                    {isResponsibleMode ? `Responsables (${scenarios.length})` : `Scénarios de Risque (${scenarios.length})`}
                </div>

                {scenarios.map((item) => {
                    const metrics = item.advancementMetrics || {};
                    const isSelected = selectedScenario?.id === item.id;

                    return (
                        <button
                            key={item.id}
                            onClick={() => onSelectScenario(item)}
                            className={`w-full text-left p-2 rounded-lg transition-all border ${isSelected
                                ? 'bg-blue-50 border-blue-200 shadow-sm z-10'
                                : 'bg-transparent border-transparent hover:bg-gray-50'
                                }`}
                        >
                            <div className="flex justify-between items-start mb-0.5">
                                <span className={`text-xs font-medium line-clamp-2 ${isSelected ? 'text-blue-900' : 'text-gray-700'}`}>
                                    {item.name}
                                </span>
                            </div>

                            <div className="flex items-center justify-between mt-1 pl-0.5">
                                <div className="flex items-center gap-2">
                                    {!isResponsibleMode && metrics.riskReduction > 0 && (
                                        <div className="flex items-center gap-1 text-[9px] text-gray-500 bg-gray-100 px-1 py-0.5 rounded border border-gray-200">
                                            <Shield className="w-2.5 h-2.5" />
                                            -{metrics.riskReduction}%
                                        </div>
                                    )}
                                    {isResponsibleMode && (
                                        <div className="text-[9px] text-gray-400">
                                            {metrics.implementedMeasures}/{metrics.totalMeasures}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ScenarioSidebar;
